import { useQuery } from "@tanstack/react-query";
import { DateTime } from "luxon";

import { settingsAjax } from "../../ajax/SettingsAjax";
import { TripleShift } from "../../types/Shift";
import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";

function useShiftLockInfo(selectedDate?: DateTime, selectedShift?: TripleShift) {
  const { data, isLoading: isShiftLockInfoLoading } = useQuery({
    queryKey: ['shiftLockInfo', selectedDate?.toISODate() ?? null, selectedShift ?? null],
    queryFn: async () => {
      const response = await settingsAjax.getShiftLockInfo();
      return ErrorResponse.isErrorResponse(response) ? null : response;
    },
  });

  return { shiftLockState: data ?? null, isShiftLockInfoLoading };
}

export default useShiftLockInfo
